var lib_core = require("lib-core");

var LogicTerminalData = function (name) {
    this.makeObservableTreeNode();

    this.name = this.value("name", true);
    if (name != undefined) this.name(name);
};
lib_core.mixin(LogicTerminalData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(LogicTerminalData, "LogicTerminalData");

module.exports = LogicTerminalData;

LogicTerminalData.prototype.getMappedTerminals = function () {
    return this.parent().inverseTerminalMap.get(this);
};
